import React from 'react'
import styled from '@emotion/styled'
import { Trash2 } from 'react-feather'

import Table, { TableRow, TableCell } from 'Components/Table'
import Countdown from 'Components/shared/Countdown'
import { colors } from 'Constants'

import InvitesService from 'Services/invites'
import { toastWithErrorMessage } from 'Helpers/toast'
import { copyToClipboard } from 'Helpers'
import config from 'Config'
import { toast } from 'react-toastify'

const UsesCell = ({ data }) => {
  const { uses } = data
  return <TableCell>{uses.maxCount ? uses.maxCount - uses.count : '∞'}</TableCell>
}

const ExpiresInCell = ({ data }) => {
  return (
    <TableCell>
      {data.expiresOn ? (
        <Countdown completion={<span>Expired</span>} date={data.expiresOn} />
      ) : (
        <span>∞</span>
      )}
    </TableCell>
  )
}

const TableRowClickableStyle = styled(TableRow)`
  cursor: pointer;
  > * {
    transition: 0.2s background-color;
  }

  :hover {
    > * {
      background-color: ${colors.background900};
    }
  }
`

const TableInviteRowClickable = ({ data, ...props }) => (
  <TableRowClickableStyle
    onClick={() => {
      copyToClipboard(`${config.client.getUrl()}/login?setupAccount=true&code=${data.code}`)
      toast.success('Copied invite link to clipboard')
    }}
    data={data}
    {...props}
  />
)

const columns = [
  {
    header: 'Code',
    accessor: 'code'
  },
  {
    header: 'Expires In',
    accessor: 'expiresOn',
    Cell: ExpiresInCell
  },
  {
    header: 'Remaining uses',
    accessor: 'uses',
    Cell: UsesCell
  }
]

export default ({ invites, setInvites, canArchive }) => {
  const DeleteCell = ({ data }) => (
    <TableCell
      xAlign
      onClick={e => {
        e.stopPropagation()
        const inviteId = data.id

        InvitesService.update({
          inviteId,
          archived: true
        })
          .then(() => {
            invites.splice(
              invites.findIndex(val => val.id === inviteId),
              1
            )
            setInvites([...invites])
          })
          .catch(toastWithErrorMessage('Failed to archive invite'))
      }}
    >
      <Trash2 />
    </TableCell>
  )

  const newColumns = canArchive
    ? [...columns, { header: 'Archive', size: '0.2x', accessor: 'delete', Cell: DeleteCell }]
    : columns

  return (
    <Table
      columns={newColumns}
      data={invites.filter(invite => !invite.archived)}
      Row={TableInviteRowClickable}
    />
  )
}
